import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=41d5d53a&"
import script from "./Workflows.vue?vue&type=script&lang=js&"
export * from "./Workflows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports